import React from 'react';
import AdminNav from './AdminNav';
import ContactQueries from './ContactQueries';
import './AdminLayout.css';

function ManageContactQueries() {
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <>
      <AdminNav onLogout={handleLogout} />
      <div className="admin-page-wrapper">
        <div className="admin-page-container">
          <div className="admin-page-header">
            <h1 className="admin-page-title">Contact Queries</h1>
            <p className="admin-page-subtitle">View and manage customer queries submitted via the Contact page</p>
          </div>
          <ContactQueries />
        </div>
      </div>
    </>
  );
}

export default ManageContactQueries;
